import { projectLayout } from '@atlassian/jira-project-layout/src/index.tsx';
import { composeLayouts, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';

export const polarisProjectLayout: Layout = composeLayouts(projectLayout);
